import { ClearDomElement, AddDiv } from '../engine/viewer/domutils.js';
import { Loc } from '../engine/core/localization.js';
import { NavigatorPanel } from './navigatorpanel.js';
import { TreeViewGroupItem, TreeViewSingleItem } from './treeview.js';

export class NavigatorRigPanel extends NavigatorPanel
{
    constructor (parentDiv)
    {
        super (parentDiv);
        this.rig = null;
        this.summaryDiv = AddDiv (this.panelDiv, 'ov_navigator_rig_summary');
    }

    GetName ()
    {
        return Loc ('Rig');
    }

    GetIcon ()
    {
        return 'tree_mesh';
    }

    Clear ()
    {
        super.Clear ();
        this.rig = null;
        ClearDomElement (this.summaryDiv);
    }

    GetRig ()
    {
        return this.rig;
    }

    Fill (importResult)
    {
        this.Clear ();
        this.rig = importResult.rig;

        if (this.rig === null || this.rig.bones.length === 0) {
            AddDiv (this.summaryDiv, 'ov_navigator_rig_empty', Loc ('No rig or bone hierarchy found.'));
            return;
        }

        AddDiv (this.summaryDiv, 'ov_navigator_rig_stat', 'Bones: ' + this.rig.bones.length.toString ());
        AddDiv (this.summaryDiv, 'ov_navigator_rig_stat', 'Root bones: ' + this.rig.rootBoneIds.length.toString ());

        let addBoneItem = (boneId, parentItem) => {
            let bone = this.rig.bones[boneId];
            let item = null;
            if (bone.children.length > 0) {
                item = new TreeViewGroupItem (bone.name, 'tree_mesh');
                item.ShowChildren (true);
            } else {
                item = new TreeViewSingleItem (bone.name, 'model');
            }

            if (parentItem === null) {
                this.treeView.AddChild (item);
            } else {
                parentItem.AddChild (item);
            }

            for (let childBoneId of bone.children) {
                addBoneItem (childBoneId, item);
            }
        };

        for (let rootBoneId of this.rig.rootBoneIds) {
            addBoneItem (rootBoneId, null);
        }
    }
}
